/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Partner_Admin_Commission_Approved_OnInputs */



/**
* | output |
* | --- |
* | "Approved {date}" |
*
* @param {Partner_Admin_Commission_Approved_OnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_commission_approved_on = /** @type {((inputs: Partner_Admin_Commission_Approved_OnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Commission_Approved_OnInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Freigegeben ${i?.date}`)
	return /** @type {LocalizedString} */ (`Approved ${i?.date}`)
});